// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';
import ListViewShowMore from '../../../shared/components/list-view-show-more';
import TransferEnterAor from '@deere/cps-it.warranty-model-factory/lib/transfer-enter-aor';
import TransferSearchResult from './transfer-search-result';

const TransferList = props => {

    let list;

    if (props.transfers.length) {

        const transfers = props.transfers.map(transfer =>
            <TransferSearchResult
                key={transfer.id}
                transfer={transfer}
                updateCommentAction={props.updateCommentAction}
                updateRejectedReason={props.updateRejectedReason}
                updateStatusAction={props.updateStatusAction}
            />
        );

        list = (
            <ListViewShowMore
                initialShowItems={50}
                perMoreMultiplier={1.25}
                showAllOption={true}
                showPerMore={50}
                totalItems={props.transfers.length}
            >
                {transfers}
            </ListViewShowMore>
        );

    } else {

        list = <span className='empty'><FormattedMessage id='NO_RESULTS_FOUND'/></span>;

    }

    return (
        <div className='product-list'>
            <div className='list-header'>
                {props.children}
            </div>
            {list}
        </div>
    );

};

TransferList.displayName = 'TransferList';
TransferList.propTypes = {
    children: PropTypes.node,
    transfers: PropTypes.arrayOf(PropTypes.instanceOf(TransferEnterAor)).isRequired,
    updateCommentAction: PropTypes.func.isRequired,
    updateRejectedReason: PropTypes.func,
    updateStatusAction: PropTypes.func.isRequired
};

export default TransferList;



// WEBPACK FOOTER //
// ./src/product/transfers/components/transfer-list.js